import DocumentVerificationPast from "../components/DocumentVerification/DocumentVerificationPast";

const DocumentVerificationPastScreen = () => <DocumentVerificationPast />;

export default DocumentVerificationPastScreen;
